import { Layout as AntLayout } from 'antd';
import Loader from 'react-top-loading-bar';
import styled from 'styled-components';
import { Page } from 'components/molecules/page';
import { Text02 } from 'components/styles';

export const Progress = styled(Loader).attrs({
  color: 'var(--blue-60)',
})`
  position: absolute !important;
  z-index: var(--zindex-layer-02) !important;
`;

export const StyledPage = styled(Page)<{
  $island: boolean;
}>`
  padding-top: 0;
  margin-top: ${({ $island }) => ($island ? '8px' : '0')};
  border-radius: ${({ $island }) =>
    $island ? 'var(--border-radius-small)' : '0'};
  padding-right: ${({ $island }) => ($island ? '0' : '8px')};
  margin-right: ${({ $island }) => ($island ? '8px' : '0')};
  padding-bottom: 0;
  height: ${({ $island }) => ($island ? 'calc(-16px + 100vh)' : '100vh')};
  overflow: hidden;
  ${Page.Header} {
    border-radius: 0 var(--border-radius-small) 0 0;
  }
  ${Page.Content} {
    border-radius: 0 0 var(--border-radius-small) 0;
  }
`;

export const Layout = styled(AntLayout)`
  align-items: stretch;
  height: 100%;
  width: 100%;
  overflow: hidden;

  div[data-resizing='true'] .ant-layout-sider {
    transition: all 0s;
  }
  /* enable transition when closing and opening sidebar */
  .resizable-wrapper {
    transition: all 0.3s cubic-bezier(0.29, 0.04, 0.23, 1);
  }
`;

export const Sider = styled(Layout.Sider)<{ $border?: boolean }>`
  flex: 0 0 256px;
  max-width: 256px;
  min-width: 256px;
  width: 256px;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
  background: var(--white-100);
  border-right: ${(props) =>
    props.$border ? '1px solid var(--border-color)' : 'none'};
  [data-new-theme-enabled='true'] & {
    border-right: ${(props) =>
      props.$border ? '1px solid var(--scarlet-gray-30)' : 'none'};
  }
`;

export const Content = styled(Layout.Content)`
  align-items: stretch;
  height: 100%;
  width: 100%;
  overflow: hidden;
`;

export const ContentWrapper = styled.div<{ $full?: boolean }>`
  position: relative;
  width: 100%;
  height: ${({
    $full = false,
    theme: {
      filters: { height },
    },
  }) => ($full ? '100%' : `calc(100% - ${height}px)`)};
  overflow: hidden;
`;

export const BannerWrapper = styled.div`
  overflow: hidden;
  width: 100%;
  margin: 0;
  padding: var(--spacing-03) var(--left-spacing);
  border-bottom: 1px solid rgba(0, 0, 0, 0.11);
  position: relative;
`;

export const HelpText = styled.div`
  ${Text02};
`;
